import { Banknote, Printer, ReceiptText, RefreshCw, XCircle } from 'lucide-react'

import { Button, CheckboxField, TextField } from '@krp/ui-kit'

import type { PaymentVerdictActions, PaymentVerdictVm } from '../port/types'

const ACTION_ICON = {
  recover: Printer,
  'record-receipt': ReceiptText,
  'payment-not-taken': XCircle,
} as const

/**
 * Сверка чека по двум галочкам (решение владельца 04.11.2026, RP-CASH-RECOVERY §4.2): «Деньги списаны» — предзаполнена системой с
 * доказательством, «Чек пробит в ФН» — снята, пока чек не известен. Одно основное действие по галочкам; недоступно — рядом причина
 * словами, а не мёртвая кнопка. Обязательных причин и «что проверено» нет. Вторичные кнопки («Назад», «Готово») рисует владелец формы.
 */
export function ReceiptVerdict({ verdict, actions }: { verdict: PaymentVerdictVm; actions: PaymentVerdictActions }) {
  const locked = verdict.busy || verdict.outcomeUnknown
  const Icon = ACTION_ICON[verdict.action]
  return (
    <div className="sale-form" role="group" aria-label="Сверка по галочкам">
      <CheckboxField
        label={
          <>
            <Banknote size={14} aria-hidden="true" /> Деньги списаны (терминал)
          </>
        }
        checked={verdict.moneyTaken}
        disabled={!verdict.moneyEditable || locked}
        onChange={actions.moneyChanged}
      />
      {verdict.moneyEvidence !== null && <p className="sale-text">{verdict.moneyEvidence}</p>}
      <CheckboxField
        label={
          <>
            <ReceiptText size={14} aria-hidden="true" /> Чек пробит в ФН
          </>
        }
        checked={verdict.fiscalized}
        disabled={!verdict.moneyTaken || locked}
        onChange={actions.fiscalChanged}
      />
      {verdict.fiscalEvidence !== null && <p className="sale-text">{verdict.fiscalEvidence}</p>}
      {verdict.receiptNumberRequired && (
        <TextField label="Номер чека (обязательно)" value={verdict.receiptNumber} onChange={actions.receiptNumberChanged} />
      )}
      <p className="sale-text">{verdict.actionHint}</p>
      {verdict.blockedReason !== null && <p className="sale-text">{verdict.blockedReason}</p>}
      <div className="rmk-progress__actions">
        {verdict.outcomeUnknown ? (
          <Button variant="primary" icon={<RefreshCw size={16} aria-hidden="true" />} onClick={actions.checkStatus}>
            Проверить статус
          </Button>
        ) : (
          <Button
            variant={verdict.action === 'payment-not-taken' ? 'danger' : 'primary'}
            icon={<Icon size={16} aria-hidden="true" />}
            disabled={!verdict.canAct}
            busy={verdict.busy}
            onClick={actions.act}
          >
            {verdict.actionText}
          </Button>
        )}
      </div>
    </div>
  )
}
